import { createAction, createReducer } from 'deox';

import { pick } from 'ramda';

export interface CachedAttributes {
  applicantEmail: string | null;
  storeNumber: string | null;
  cardChoice: number | null;
  selectedCardKey: string | null;
}

const cachedAttributeKeys: (keyof CachedAttributes)[] = [
  'applicantEmail',
  'storeNumber',
  'cardChoice',
  'selectedCardKey',
];

export interface CachedAttributesState {
  entity: CachedAttributes;
}

export const defaultState: CachedAttributesState = {
  entity: {
    applicantEmail: null,
    storeNumber: null,
    cardChoice: null,
    selectedCardKey: null,
  },
};

export const mergeCachedAttributes = createAction(
  'MERGE_CACHED_ATTRIBUTES',
  resolve => (data: Partial<CachedAttributes>) => resolve(data),
);

export const cachedAttributesReducer = createReducer(
  defaultState,
  handleAction => [
    handleAction(mergeCachedAttributes, (state, { payload: data }) => {
      return {
        ...state,
        entity: {
          ...state.entity,
          ...pick(cachedAttributeKeys, data),
        },
      };
    }),
  ],
);

export interface MountedState {
  cachedAttributes: ReturnType<typeof cachedAttributesReducer>;
}

export const selectCachedAttributes = (state: MountedState): CachedAttributes =>
  state.cachedAttributes.entity;

export default cachedAttributesReducer;
